import {
    Button,
    Flex,
    Popover,
    PopoverBody,
    PopoverCloseButton,
    PopoverContent,
    PopoverFooter,
    PopoverHeader,
    PopoverTrigger,
} from "@chakra-ui/react";
import { FormikProps, FormikValues } from "formik";
import { Link as RouterLink, useNavigate } from "react-router-dom";

interface Props {
    formik: FormikProps<FormikValues>;
}

export const SubmissionBar = ({formik}: Props) => {

    const navigate = useNavigate();

    return (
        <Flex
            mt={5}
            justifyContent={"flex-end"}
            w={"100%"}
        >
            {formik.dirty && !formik.isSubmitting ? (
            <Popover placement={"right-start"}>
                <PopoverTrigger>
                <Button variant={"whiteBoxButton"} mr={3}>
                    Cancel
                </Button>
                </PopoverTrigger>
                <PopoverContent
                bg={"text.dark"}
                color={"white"}
                _focus={{
                    boxShadow: "none",
                }}
                >
                <PopoverCloseButton />
                <PopoverHeader fontWeight={"bold"} fontSize={"18px"}>
                    Form Partially Filled
                </PopoverHeader>
                <PopoverBody>
                    Are you sure you want to discard the data entered so
                    far?
                </PopoverBody>
                <PopoverFooter d={"flex"} justifyContent={"flex-end"}>
                    <Button
                    onClick={() => navigate("../")}
                    variant={"primary"}
                    bg={"red.500"}
                    color={"white"}
                    size={"sm"}
                    >
                    Yes
                    </Button>
                </PopoverFooter>
                </PopoverContent>
            </Popover>
            ) : (
            <Button
                as={RouterLink}
                mr={3}
                to={"../"}
                variant={"whiteBoxButton"}
            >
                Cancel
            </Button>
            )}
            <Button
                type={"submit"}
                variant={"blueButton"}
                disabled={
                  !(
                    formik.isValid &&
                    formik.dirty
                  )
                }
                isLoading={formik.isSubmitting}
                onClick={() => {
                    formik.submitForm();
                }}
            >
            Create Campaign
            </Button>
        </Flex>
    )
}
